import ouiBase from '@goldwasserexchange/oui';
import { useAccountPositionsHistoryFieldApiByHisMvtId } from '../api';

export const useAccountPositionsHistoryHisMvtOperDate = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountPositionsHistoryFieldApiByHisMvtId({
    hisMvtId,
    field: 'HIS_MVT.OPER_DATE',
  });
  return result;
};
